import { useAdminIncorporationController_findOneById } from '@api-client/generated/AdminIncorporationController/findOneById';
import { Loader } from '@components';
import { IncorporationLoadError } from '@entities/onboarding/IncorporationLoadError';
import { OnboardingCard } from '@entities/onboarding/OnboardingCard';
import { shouldRetryIncorporation } from '@entities/onboarding/helpers';
import { useCurrentCompany, useCurrentCompanyId } from '@hooks';

import * as S from './styled';

const Onboarding = () => {
  const companyId = useCurrentCompanyId();

  // For the compliance link only, and read here rather than in the card so the card stays
  // presentational: `useCurrentCompany` throws outside the `/companies/:companyId` route, and this
  // is the same react-query entry the Company info tab holds, so it usually costs no request.
  const { data: company } = useCurrentCompany();

  const {
    data,
    isPending: isLoading,
    isError,
    error,
    refetch,
  } = useAdminIncorporationController_findOneById({
    params: {
      companyId,
    },
    config: {
      retry: shouldRetryIncorporation,
    },
  });

  // A failed request leaves `data` undefined with `isLoading` already false, so without this
  // branch the tab spun forever instead of saying why it is empty.
  if (isError && !data) {
    return <IncorporationLoadError error={error} onRetry={refetch} />;
  }

  if (isLoading || !data) {
    return <Loader />;
  }

  return (
    <S.Container>
      <OnboardingCard
        companyId={companyId}
        companyStatus={company?.status}
        data={data}
      />
    </S.Container>
  );
};

export default Onboarding;
